module.exports = __webpack_public_path__ + "img/logo-club.9bc71b52.svg";